import React from "react";

const ImageIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="20" height="20"
         viewBox="0 0 20 20">
        <defs>
            <path id="y3oqa"
                  d="M643 1129v8.919l-3.375-2.7a1 1 0 0 0-1.332.074l-4.42 4.42-2.318-1.545a1 1 0 0 0-1.07-.025l-3.485 2.091V1129zm-16 16v-2.434l3.972-2.383 2.473 1.649a1 1 0 0 0 1.262-.125l4.367-4.367 3.926 3.14v4.52zm6-8c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3m0-4c.551 0 1 .449 1 1 0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.551.449-1 1-1m-7-6a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-18a1 1 0 0 0-1-1z"/>
            <clipPath id="y3oqb">
                <use xlinkHref="#y3oqa"/>
            </clipPath>
        </defs>
        <g>
            <g transform="translate(-625 -1127)">
                <g>
                    <use fill="#31373d" xlinkHref="#y3oqa"/>
                </g>
                <g clipPath="url(#y3oqb)">
                    <g>
                        <path fill="#919eab" d="M1127 625h21v21h-21z"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>

);

export default ImageIcon;
